import {React} from '@api';
import {PdfExportStore} from '@modules/pdf/PdfExportStore'
import {StyleSheet, View, Text} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footer: {
    padding:        8,
    flexShrink:     0,
    flexGrow:       0,
    display:        'flex',
    flexDirection:  'row',
    alignItems:     'center',
    borderTopWidth: 1,
    borderTopColor: '#dedede',
    borderTopStyle: 'solid'
  },
  text:   {
    //fontFamily: 'roboto',
    margin:   'auto 0',
    fontSize: 12,
    flexGrow: 1
  },
  seasonalBreadcrumbs: {

  },
  pageNumber: {
    margin: 'auto',
    fontSize: 14,
    //fontFamily: 'Helvetica'
  }

})

interface MyProps {
  page?: number,
  totalPages?: number,
  pdf: PdfExportStore
}

// export class PdfFooter extends React.Component<MyProps> {
//   render() {
//     const {props: {page, totalPages, children, pdf}} = this,
//       {config: {footer: {show, showPage}}} = pdf
//     return !show ? null :
//            <View style={styles.footer}>
//              {children}
//
//              {page && totalPages && showPage ? <PageNumberPdf page={page} totalPages={totalPages} /> : null}
//            </View>
//   }
// }

export class PageNumberPdf extends React.Component<{page: number, totalPages: number}> {
  render() {
    const {props: {page, totalPages}} = this
    return <View style={styles.pageNumber}>
      <Text>{page} of {totalPages}</Text>
    </View>
  }
}
/*

@observer
export class SeasonalBreadcrumbsPdf extends React.Component<{
  season?: string
  category1?: string
  category2?: string}> {
  render() {
    const {season, category1, category2} = this

    return <View style={styles.seasonalBreadcrumbs}>
      {(season || category1 || category2) && <Text style={styles.text}>{season.name} > {category1.name} > {category2.name}</Text>}
    </View>
  }

  @computed get season() {
  const {props: {season}} = this
  return !season ? null : site.seasonsDict[season]
  }

  @computed get category1() {
  const {props: {category1}} = this
  return !category1 ? null : site.category1sDict[category1]
  }

  @computed get category2() {
  const {props: {category2}} = this
  return !category2 ? null : site.category2sDict[category2]
  }
}*/



// WEBPACK FOOTER //
// ./src/modules/pdf/PdfFooter.tsx